import {
  Breadcrumbs,
  ButtonLink,
  ChevronRightIcon,
  Skeleton,
  Stack,
  Typography,
} from '@razz-team/ui-web';
import { LinkProps } from '@tanstack/react-router';
import { ReactNode } from 'react';

export function MainBreadcrumbs({
  title,
  action,
  loading,
  parent,
}: {
  title: ReactNode;
  action?: ReactNode;
  loading?: boolean;
  parent?: Pick<LinkProps, 'to' | 'params' | 'search'> & { loading?: boolean; title?: ReactNode };
}) {
  const titleTypography = (
    <Typography variant="h4" aria-current="page">
      {loading ? <Skeleton width={128} /> : title}
    </Typography>
  );

  return (
    <Breadcrumbs
      aria-label="Breadcrumb"
      separator={<ChevronRightIcon fontSize="small" />}
      sx={{ p: 1.5 }}
    >
      {parent?.loading ? (
        <Typography variant="h4">
          {/* default payout name length */}
          <Skeleton width={176.5} />
        </Typography>
      ) : parent?.title ? (
        <ButtonLink variant="text" to={parent.to} params={parent.params} search={parent.search}>
          <Typography variant="h4">{parent.title}</Typography>
        </ButtonLink>
      ) : null}

      {action ? (
        <Stack direction="row" spacing={1} alignItems="center">
          {titleTypography}
          {action}
        </Stack>
      ) : (
        titleTypography
      )}
    </Breadcrumbs>
  );
}
